export default "__VITE_ASSET__C_VZ4Gr8__"